import React from "react";
import { IMaskInput } from "react-imask";

const SSNMask = React.forwardRef(function SSNMask(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000-00-0000"
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite="shift"
    />
  );
});

export default SSNMask;
